// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","redes":"Footer_redes__gCEni"};